var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7258 56H37.1918V43.994H34.6358V51.77L29.0738 43.994H26.4458V56H29.0018V47.936L34.7258 56ZM38.9831 50.006C38.9831 53.624 41.6291 56.216 45.2471 56.216C48.8831 56.216 51.5291 53.624 51.5291 50.006C51.5291 46.388 48.8831 43.796 45.2471 43.796C41.6291 43.796 38.9831 46.388 38.9831 50.006ZM48.9011 50.006C48.9011 52.238 47.4611 53.948 45.2471 53.948C43.0331 53.948 41.6111 52.238 41.6111 50.006C41.6111 47.756 43.0331 46.064 45.2471 46.064C47.4611 46.064 48.9011 47.756 48.9011 50.006ZM61.6028 56H64.0688V43.994H61.5128V51.77L55.9508 43.994H53.3228V56H55.8788V47.936L61.6028 56ZM66.436 56H74.932V53.786H68.992V50.996H74.806V48.8H68.992V46.19H74.932V43.994H66.436V56Z",
    fill: "#737e8c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoneIcon);
export default __webpack_public_path__ + "static/media/None-icon.49d084ead9a1bd86d3a5a2bd74532043.svg";
export { ForwardRef as ReactComponent };